
export default {
  namespaced: true,
  state: {
    showCalendarOnTop: false,
  },
  mutations: {
    toggleCalendarOnTop(state) {
      if (!state.showCalendarOnTop) {
        window.scrollTo(0, 0);
      }
      Object.assign(state, { showCalendarOnTop: !state.showCalendarOnTop });
    },
  },
  actions: {
    toggleCalendarOnTop(context) {
      context.commit('toggleCalendarOnTop');
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/public/activityUI.js